import { lao } from './lao';
import { laoUx } from './lao-ux';
import { laoConnections } from './lao-connections';
import { laoChatbot } from './lao-chatbot';
import { laoProduct } from './lao-product';
import { laoHotel } from './lao-hotel';
import { laoHotelSettings } from './lao-hotel-settings';
import { laoHotelWorkspace } from './lao-hotel-workspace';
import { laoHotelPayments } from './lao-hotel-payments';
import { laoHotelCancellation } from './lao-hotel-cancellation';
import { laoHotelRates } from './lao-hotel-rates';
import { laoHotelBookingEngine } from './lao-hotel-booking-engine';
import { laoHotelMessaging } from './lao-hotel-messaging';
import { laoHotelBookingChat } from './lao-hotel-booking-chat';
import { laoHotelPropertyContent } from './lao-hotel-property-content';
import { laoHotelDailyClose } from './lao-hotel-daily-close';
import { laoAudit } from './lao-audit';
import { createContext, useContext, useState, useEffect, useMemo, type ReactNode } from 'react';
const lo: Record<string, string> = {
  Overview: 'ພາບລວມ',
  'Sales & income': 'ການຂາຍ ແລະ ລາຍຮັບ',
  'Purchases & expenses': 'ການຊື້ ແລະ ລາຍຈ່າຍ',
  Inventory: 'ສາງສິນຄ້າ',
  'People & payroll': 'ພະນັກງານ ແລະ ເງິນເດືອນ',
  'Cash & assets': 'ເງິນສົດ ແລະ ຊັບສິນ',
  Accounting: 'ບັນຊີ',
  Reports: 'ລາຍງານ',
  Settings: 'ຕັ້ງຄ່າ',
  'Document settings': 'ຕັ້ງຄ່າເອກະສານ',
  'Control center': 'ສູນຄວບຄຸມ',
  Workspace: 'ພື້ນທີ່ທຸລະກິດ',
  Workspaces: 'ພື້ນທີ່ທຸລະກິດ',
  Memberships: 'ສະມາຊິກ',
  'Add-ons': 'ສ່ວນເສີມ',
  'Release tracks': 'ຊ່ອງທາງອັບເດດ',
  'Activity log': 'ປະຫວັດການໃຊ້ງານ',
  'API & connections': 'API ແລະ ການເຊື່ອມຕໍ່',
  'Platform health': 'ສະຖານະລະບົບ',
  'Back to workspace': 'ກັບໄປທຸລະກິດ',
  'Good afternoon, Sengdao': 'ສະບາຍດີ ແສງດາວ',
  'Your business, at a glance.': 'ພາບລວມທຸລະກິດຂອງທ່ານ',
  Income: 'ລາຍຮັບ',
  Expenses: 'ລາຍຈ່າຍ',
  'Net cash flow': 'ກະແສເງິນສົດສຸດທິ',
  Receivables: 'ລູກໜີ້',
  Payables: 'ເຈົ້າໜີ້',
  'Cash flow': 'ກະແສເງິນສົດ',
  'Recent transactions': 'ທຸລະກຳລ່າສຸດ',
  'Available balance': 'ຍອດເງິນທີ່ມີ',
  'Needs attention': 'ລາຍການທີ່ຕ້ອງຕິດຕາມ',
  'All transactions': 'ທຸລະກຳທັງໝົດ',
  'New transaction': 'ສ້າງທຸລະກຳ',
  'New invoice': 'ສ້າງໃບແຈ້ງໜີ້',
  'View all': 'ເບິ່ງທັງໝົດ',
  'Last 30 days': '30 ມື້ຜ່ານມາ',
  'This month': 'ເດືອນນີ້',
  'This year': 'ປີນີ້',
  'Search anything…': 'ຄົ້ນຫາ…',
  'Search records…': 'ຄົ້ນຫາລາຍການ…',
  Search: 'ຄົ້ນຫາ',
  'Demo workspace': 'ທຸລະກິດຕົວຢ່າງ',
  'Business workspace': 'ພື້ນທີ່ທຸລະກິດ',
  Save: 'ບັນທຶກ',
  'Save draft': 'ບັນທຶກຮ່າງ',
  Cancel: 'ຍົກເລີກ',
  Close: 'ປິດ',
  Create: 'ສ້າງ',
  Edit: 'ແກ້ໄຂ',
  Export: 'ສົ່ງອອກ',
  Import: 'ນຳເຂົ້າ',
  Print: 'ພິມ',
  Post: 'ລົງບັນຊີ',
  Approve: 'ອະນຸມັດ',
  Void: 'ຍົກເລີກລາຍການ',
  Archive: 'ເກັບເຂົ້າປະຫວັດ',
  Restore: 'ກູ້ຄືນ',
  Name: 'ຊື່',
  'Name in Lao': 'ຊື່ພາສາລາວ',
  Description: 'ລາຍລະອຽດ',
  Reference: 'ອ້າງອີງ',
  Date: 'ວັນທີ',
  'View chart data': 'ເບິ່ງຂໍ້ມູນກຣາຟ',
  'Booked / sellable rooms': 'ຫ້ອງທີ່ຈອງ / ຫ້ອງທີ່ຂາຍໄດ້',
  'Due date': 'ວັນຄົບກຳນົດ',
  Status: 'ສະຖານະ',
  Amount: 'ຈຳນວນເງິນ',
  Currency: 'ສະກຸນເງິນ',
  Customer: 'ລູກຄ້າ',
  Customers: 'ລູກຄ້າ',
  Vendor: 'ຜູ້ສະໜອງ',
  Vendors: 'ຜູ້ສະໜອງ',
  Invoices: 'ໃບແຈ້ງໜີ້',
  Invoice: 'ໃບແຈ້ງໜີ້',
  Quotations: 'ໃບສະເໜີລາຄາ',
  Quotation: 'ໃບສະເໜີລາຄາ',
  Receipts: 'ໃບຮັບເງິນ',
  Receipt: 'ໃບຮັບເງິນ',
  'Point of sale': 'ຂາຍໜ້າຮ້ານ',
  Sale: 'ການຂາຍ',
  'Sale sessions': 'ຮອບການຂາຍ',
  'Purchase orders': 'ໃບສັ່ງຊື້',
  'Purchase order': 'ໃບສັ່ງຊື້',
  Bills: 'ໃບເກັບເງິນ',
  Bill: 'ໃບເກັບເງິນ',
  Payments: 'ການຈ່າຍເງິນ',
  Payment: 'ການຈ່າຍເງິນ',
  'Products & services': 'ສິນຄ້າ ແລະ ບໍລິການ',
  Product: 'ສິນຄ້າ',
  Warehouses: 'ສາງ',
  Warehouse: 'ສາງ',
  'Stock lots': 'ລັອດສິນຄ້າ',
  'Stock movements': 'ການເຄື່ອນໄຫວສິນຄ້າ',
  'Stock transfers': 'ການໂອນສິນຄ້າ',
  'Production orders': 'ການຜະລິດ',
  'Unit conversions': 'ການປ່ຽນຫົວໜ່ວຍ',
  Units: 'ຫົວໜ່ວຍ',
  'Product categories': 'ໝວດສິນຄ້າ',
  'Overhead categories': 'ໝວດຄ່າໃຊ້ຈ່າຍຜະລິດ',
  Employees: 'ພະນັກງານ',
  Employee: 'ພະນັກງານ',
  Departments: 'ພະແນກ',
  Department: 'ພະແນກ',
  Benefits: 'ຜົນປະໂຫຍດ',
  'Salary tax brackets': 'ຂັ້ນພາສີເງິນເດືອນ',
  'Payroll runs': 'ລາຍການເງິນເດືອນ',
  'Payroll run': 'ລາຍການເງິນເດືອນ',
  'Cash & bank accounts': 'ເງິນສົດ ແລະ ບັນຊີທະນາຄານ',
  'Money transfers': 'ການໂອນເງິນ',
  'Fixed assets': 'ຊັບສິນຖາວອນ',
  'Chart of accounts': 'ຜັງບັນຊີ',
  'General journals': 'ບັນຊີປະຈຳວັນ',
  'Opening balances': 'ຍອດຍົກມາ',
  Adjustments: 'ລາຍການປັບປຸງ',
  'Close accounts': 'ປິດບັນຊີ',
  Categories: 'ໝວດໝູ່',
  Category: 'ໝວດໝູ່',
  Tags: 'ປ້າຍກຳກັບ',
  Currencies: 'ສະກຸນເງິນ',
  'Tax rates': 'ອັດຕາພາສີ',
  Email: 'ອີເມລ',
  Phone: 'ເບີໂທ',
  Address: 'ທີ່ຢູ່',
  'Tax number': 'ເລກປະຈຳຕົວຜູ້ເສຍພາສີ',
  Notes: 'ໝາຍເຫດ',
  'Internal notes': 'ໝາຍເຫດພາຍໃນ',
  Total: 'ລວມ',
  Subtotal: 'ລວມຍ່ອຍ',
  Discount: 'ສ່ວນຫຼຸດ',
  Tax: 'ພາສີ',
  Quantity: 'ຈຳນວນ',
  Price: 'ລາຄາ',
  'Add item': 'ເພີ່ມລາຍການ',
  Items: 'ລາຍການ',
  'Payment account': 'ບັນຊີຮັບຈ່າຍ',
  'Apply to invoice': 'ຊຳລະໃບແຈ້ງໜີ້',
  'Apply to bill': 'ຊຳລະໃບເກັບເງິນ',
  'Purchase price': 'ລາຄາຊື້',
  'Sale price': 'ລາຄາຂາຍ',
  'Opening quantity': 'ຈຳນວນຍົກມາ',
  'Minimum quantity': 'ຈຳນວນຂັ້ນຕ່ຳ',
  'Expiry date': 'ວັນໝົດອາຍຸ',
  Code: 'ລະຫັດ',
  Balance: 'ຍອດເງິນ',
  Type: 'ປະເພດ',
  'Base salary': 'ເງິນເດືອນພື້ນຖານ',
  'Bank account': 'ບັນຊີທະນາຄານ',
  Attachments: 'ເອກະສານແນບ',
  Company: 'ບໍລິສັດ',
  Preferences: 'ການຕັ້ງຄ່າ',
  'Team members': 'ສະມາຊິກທີມ',
  'No records yet': 'ຍັງບໍ່ມີລາຍການ',
  'No matching records': 'ບໍ່ພົບລາຍການ',
  'Try a different search or filter.': 'ລອງຄົ້ນຫາ ຫຼື ປ່ຽນຕົວກັ່ນຕອງ',
  'Loading…': 'ກຳລັງໂຫຼດ…',
  'Saved successfully': 'ບັນທຶກສຳເລັດ',
  'All statuses': 'ທຸກສະຖານະ',
  draft: 'ຮ່າງ',
  active: 'ໃຊ້ງານ',
  issued: 'ອອກແລ້ວ',
  posted: 'ລົງບັນຊີແລ້ວ',
  paid: 'ຊຳລະແລ້ວ',
  approved: 'ອະນຸມັດແລ້ວ',
  void: 'ຍົກເລີກ',
  archived: 'ເກັບປະຫວັດ',
  closed: 'ປິດແລ້ວ',
  suspended: 'ລະງັບ',
  'Sign out': 'ອອກຈາກລະບົບ',
  'Sign in': 'ເຂົ້າລະບົບ',
  Password: 'ລະຫັດຜ່ານ',
  owner: 'ເຈົ້າຂອງ',
  accountant: 'ນັກບັນຊີ',
  operator: 'ພະນັກງານ',
  viewer: 'ຜູ້ເບິ່ງ',
  'Record payment': 'ບັນທຶກການຊຳລະ',
  'Receive payment': 'ຮັບຊຳລະເງິນ',
  'Low stock': 'ສິນຄ້າໃກ້ໝົດ',
  Outstanding: 'ຍອດຄ້າງຊຳລະ',
  'vs. previous period': 'ທຽບກັບໄລຍະຜ່ານມາ',
  'All clear': 'ບໍ່ມີລາຍການຄ້າງ',
  'Manage accounts': 'ຈັດການບັນຊີ',
  Transactions: 'ທຸລະກຳ',
  Finance: 'ການເງິນ',
  Operations: 'ການດຳເນີນງານ',
  People: 'ບຸກຄະລາກອນ',
  Enable: 'ເປີດ',
  Disable: 'ປິດ',
  'Invite member': 'ເຊີນສະມາຊິກ',
  'New workspace': 'ສ້າງທຸລະກິດ',
  Plan: 'ແຜນ',
  Role: 'ສິດໃຊ້ງານ',
  Members: 'ສະມາຊິກ',
  From: 'ຈາກ',
  To: 'ເຖິງ',
  'Journal entries': 'ລາຍການບັນຊີ',
  Debit: 'ເດບິດ',
  Credit: 'ເຄຣດິດ',
  'Add line': 'ເພີ່ມແຖວ',
  Balanced: 'ດຸນດ່ຽງ',
  Refresh: 'ໂຫຼດໃໝ່',
  Previous: 'ກ່ອນໜ້າ',
  Next: 'ຕໍ່ໄປ',
  Connected: 'ເຊື່ອມຕໍ່ແລ້ວ',
};
Object.assign(
  lo,
  laoUx,
  lao,
  laoConnections,
  laoChatbot,
  laoProduct,
  laoHotel,
  laoHotelSettings,
  laoHotelWorkspace,
  laoHotelCancellation,
  laoHotelPayments,
  laoHotelRates,
  laoHotelBookingEngine,
  laoHotelBookingChat,
  laoHotelMessaging,
  laoHotelPropertyContent,
  laoHotelDailyClose,
  laoAudit,
);
type Language = 'en' | 'lo';
export const translateText = (s: string, language: Language) =>
  language === 'lo' ? lo[s] || lo[s[0]?.toUpperCase() + s.slice(1)] || s : s;
const Context = createContext({
  language: 'en' as Language,
  setLanguage: (_value: Language) => {},
  t: (s: string) => s,
});
function storedLanguage(): Language {
  try {
    return localStorage.getItem('lfb-language') === 'lo' ? 'lo' : 'en';
  } catch {
    return 'en';
  }
}
/** `persist={false}` keeps the choice to this page (the public booking page must not change staff's language). */
export function LanguageProvider({
  children,
  persist = true,
}: {
  children: ReactNode;
  persist?: boolean;
}) {
  const [language, set] = useState<Language>(() => (persist ? storedLanguage() : 'en'));
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);
  // Stable value: consumers re-render only when the language changes.
  const value = useMemo(
    () => ({
      language,
      setLanguage: (next: Language) => {
        set(next);
        try {
          if (persist) localStorage.setItem('lfb-language', next);
        } catch {
          // Storage unavailable: the choice lasts for this session only.
        }
        document.documentElement.lang = next;
      },
      t: (s: string) => translateText(s, language),
    }),
    [language, persist],
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
export const useLanguage = () => useContext(Context);
